/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Popover from '@mui/material/Popover';
import DropdownItem from 'views/Dashboards-B2B/components/DropdownItem';
import * as S from '../../../../../../../../Dashboard.styled';

type SelectCaseDropdownProps = {
    selectedCase: string;
    handleSelectedCase: (selectedCase: string) => void;
    dropdownMenuPrograms: any;
    customStyleForSearchbar?: boolean;
    dashboard?: boolean;
    onboarding?: boolean;
    mobile: boolean;
};

const SelectCaseDropdown = ({
    selectedCase,
    handleSelectedCase,
    dropdownMenuPrograms,
    customStyleForSearchbar,
    dashboard,
    onboarding,
    mobile,
}: SelectCaseDropdownProps) => {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const updateUrl = (appNum: string) => {
        const currentPath = window.location.pathname;

        if (currentPath.includes('visa-program')) {
            const currentPathArray = window.location.pathname.split('/');
            currentPathArray[currentPathArray.length - 1] = appNum;
            const newPath = currentPathArray.join('/');
            navigate(newPath, { replace: true });
        } else {
            const newPath = currentPath + '/visa-program/' + appNum;
            navigate(newPath, { replace: true });
        }
    };

    const handleOptionClick = (e: React.MouseEvent<HTMLElement>, selectedCase: any) => {
        e.stopPropagation();
        handleSelectedCase(selectedCase.name);
        updateUrl(selectedCase.id.toString());
        handleClose();
    };

    return (
        <>
            <S.LeftDropdown
                mobile={mobile}
                onboarding={onboarding}
                customStyleForSearchbar={customStyleForSearchbar}
                dashboard={dashboard}
                isActive={!!anchorEl}
                onClick={(event) => {
                    handleClick(event);
                }}
            >
                <S.SelectionContainer>{selectedCase}</S.SelectionContainer>
                <S.DropdownIcon />
            </S.LeftDropdown>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                marginThreshold={0}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                slotProps={{
                    paper: {
                        sx: {
                            overflow: 'visible',
                            mt: '8px',
                            minWidth: '7rem',
                            padding: '0',
                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.09)',
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            >
                <S.DropDownMenu>
                    {dropdownMenuPrograms.map((option: any, i: number) => {
                        return (
                            <DropdownItem
                                style={{ display: 'inline-block' }}
                                key={i}
                                onClick={(e) => handleOptionClick(e, option)}
                            >
                                {option.name}
                            </DropdownItem>
                        );
                    })}
                </S.DropDownMenu>
            </Popover>
        </>
    );
};

export default SelectCaseDropdown;
